import ButtonIcon from "ds/components/ButtonIcon";
import DropdownMenuEllipsis, {
  DropdownMenuEllipsisProps,
} from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { type TableCellAction } from ".";
import styles from "./styles.module.css";

type TableCellContentActionsProps = {
  actions: TableCellAction[];
} & Pick<DropdownMenuEllipsisProps, "onOpenChange">;

const TableCellContentActions = ({ actions, onOpenChange }: TableCellContentActionsProps) => {
  if (actions.length === 1) {
    const { icon, action, title } = actions[0];
    return (
      <ButtonIcon variant="ghost" onPress={action} icon={icon} className={styles.action}>
        {title}
      </ButtonIcon>
    );
  }

  return (
    <DropdownMenuEllipsis
      tooltip="Cell options"
      onOpenChange={onOpenChange}
      className={styles.action}
    >
      {actions.map(({ title, action }, i) => (
        <DropdownMenuItem key={i} onAction={action}>
          {title}
        </DropdownMenuItem>
      ))}
    </DropdownMenuEllipsis>
  );
};

TableCellContentActions.displayName = "DS.TableCellContentActions";

export default TableCellContentActions;
